import React from 'react';
import './index.css';
import { useWindowContext } from 'Context/WindowContext';
import SkipSentryError from 'Errors/SkipSentryError';
import FacetFacNegative from 'Icons/Brand/FacetFacNegative';
import useHomeContext from 'Context/HomeContext';

const Maintenance = () => {
  const { windowIsVisible } = useWindowContext();
  const { homeResource } = useHomeContext();
  // check every 60 seconds to see if we are back up
  // and if we are, then redirect to the login page
  const t = setInterval(() => {
    if (windowIsVisible) {
      homeResource?.withRelationship(
        'test',
        (rel) => rel.link('related').get(),
        () => ({}),
      ).then(() => {
        clearInterval(t);
        document.location.href = '/';
      }).catch(() => {
        return new SkipSentryError('Skipping /test errors'); // <-- NOTE: This is in place so the error is not sent to Sentry.io
      });
    }
  }, 60000);

  React.useEffect(() => {
    homeResource?.withRelationship(
      'test',
      (rel) => rel.link('related').get(),
      () => ({}),
    ).then(() => {
      clearInterval(t);
      document.location.href = '/';
    }).catch(() => {
      return new SkipSentryError('Skipping /test errors'); // <-- NOTE: This is in place so the error is not sent to Sentry.io
    });
  }, [windowIsVisible]);

  return (
    <div id="maintenance">
      <article>
        <FacetFacNegative />
        <h1>We&apos;ll be back soon!</h1>
        <div>
          <p>
            Sorry for the inconvenience but we&apos;re performing some
            maintenance at the moment. If you need to you can always{' '}
            <a href="mailto:support@facetwealth.com">contact us</a>, otherwise
            we&apos;ll be back online shortly!
          </p>
          <p>&mdash; The Facet Team</p>
        </div>
      </article>
    </div>
  );
};

Maintenance.propTypes = {
};

export default Maintenance;
